import React from "react";
import { Route, Redirect } from "react-router-dom";




const AppRoute = ({
	component: Component,
	layout: Layout,
	isAuthProtected,
	...rest
}) => (
		<Route
			{...rest}
			
			render={props => {
				if (isAuthProtected && !sessionStorage.getItem("authUser")) {
					return (
						<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
					);
				}

				return (
					<Layout>
						<Component {...props} />
					</Layout>
				);
				// if (validToken()[0]) {
				// 	return (
				// 		<Layout>
				// 			<Component {...props} />
				// 		</Layout>
				// 	);
				// }
				// else {
				// 	return (
				// 		<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
				// 	);
				// }
				
				// let check = validToken()[0]
				// //console.log(check)
				// console.log(isAuthProtected && check===false)

				// if (isAuthProtected) {
				// 	return (
				// 		<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
				// 	);
				// }
				
				// return (
				// 	<Layout>
				// 		<Component {...props} />
				// 	</Layout>
				// );
				
			}}
		/>
	);

export default AppRoute;

